import { useState, useEffect } from 'react';

/**
 *  Custom hook for updating retention policy
 * @param {object} initialState - initial state of data
 * @param {Function} handleUpdateRetentionPolicy - function that call the api and update the retention policy
 * @returns {Array} - Array that contains state of retention policy, set method and update method
 */
const useUpdateRetentionPolicy = (initialState, handleUpdateRetentionPolicy) => {
  const [retentionPolicy, setRetentionPolicy] = useState({
    dataRetentionPeriodLength: '',
    dataRetentionPeriod: 'Days',
    dataRetentionPolicy: false,
  });

  useEffect(() => {
    setRetentionPolicy({
      dataRetentionPeriodLength: initialState?.dataRetentionPeriodLength || '',
      dataRetentionPeriod: initialState?.dataRetentionPeriod || 'Days',
      dataRetentionPolicy: initialState?.dataRetentionPolicy || false,
    });
  }, [initialState]);

  /**
   * update retention
   * @param {object} retentionPolicy - retention policy to update
   * @returns {void}
   */
  const updateRetentionPolicy = async (retentionPolicy) => {
    handleUpdateRetentionPolicy(retentionPolicy);
  };

  // return custom hook elements
  return [retentionPolicy, setRetentionPolicy, updateRetentionPolicy];
};

export { useUpdateRetentionPolicy };
